<template>
  <section>
    <h2 class="hdg_order01"><i></i>需要家変換マスタ</h2>
    <div class="mb20 st02">
      <button
        @click="registConvertConsumerInfo"
        class="btn btn-primary"
        v-if="!isReferMode"
      >
        新規登録
      </button>
    </div>
    <table class="table table-bordered bg-white tbl_master01">
      <tbody>
        <tr>
          <th class="bg-tbl-light">お客様変換CD</th>
          <td colspan="3">
            <input
              type="text"
              class="form-control"
              v-model="searchClientdelivery_cd"
            />
          </td>
          <th class="bg-tbl-light">需要家名</th>
          <td>
            <input
              type="text"
              class="form-control"
              v-model="searchClcompany_na"
            />
          </td>
          <th class="bg-tbl-light">需要家カナ</th>
          <td>
            <input
              type="text"
              class="form-control"
              v-model="searchDlcompanyka_na"
            />
          </td>
        </tr>
      </tbody>
    </table>

    <div class="btn-center">
      <button
        type="button"
        @click="searchConvertConsumerHandler"
        class="btn btn-order btn-lg"
      >
        検索
      </button>
    </div>

    <div v-if="searchErrorResponse.message" class="alert alert-danger mt-3">
      {{ searchErrorResponse.message }}
    </div>

    <template v-if="isSearchResult">
      <h2 class="hdg_order01 mt40"><i></i>変換（需要家）マスタ一覧</h2>
      <div class="mb-3 d-flex justify-content-end">
        <bs-pagination
          :page.sync="page"
          :per-page="per_page"
          :number="searchResultLength"
        ></bs-pagination>
      </div>
      <div class="table-responsive mb-4">
        <table class="table table-bordered bg-white data_table text-nowrap">
          <thead>
            <tr class="bg-tbl-head text-white text-center">
              <th></th>
              <th style="min-width: 10em">お客様CD</th>
              <th style="min-width: 10em">Nitto需要家CD</th>
              <th style="min-width: 10em">お客様需要家名</th>
              <th style="min-width: 10em">お客様需要家カナ</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="text-center"
              v-for="JYK in filteredsearchResults"
              :key="JYK.row_no"
            >
              <td>
                <button
                  class="btn btn-primary btn-sm"
                  @click="getConvertConsumerInfoHandler(JYK)"
                  v-if="isReferMode"
                >
                  選択
                </button>
                <button
                  class="btn btn-primary btn-sm"
                  @click="getConvertConsumerInfoHandler(JYK)"
                  v-if="!isReferMode"
                >
                  編集
                </button>
              </td>
              <td>{{ JYK.clientdelivery_cd }}</td>
              <td>{{ JYK.nd_clcompany_cd }}</td>
              <td>{{ JYK.dlcompany_na }}</td>
              <td>{{ JYK.dlcompanyka_na }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>

    <template v-if="isDetailResult">
      <h2 id="detail" class="hdg_order01"><i></i>変換マスタ　詳細</h2>

      <!-- 参照モード-->
      <table
        class="table table-bordered bg-white tbl_master02"
        v-if="isReferMode"
      >
        <thead>
          <tr class="bg-tbl-head">
            <th>項目</th>
            <th>お客様データ</th>
            <th>日東側データ</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th class="bg-tbl-light">お客様変換CD</th>
            <td>{{ convertItem.clientdelivery_cd }}</td>
            <td class="bg-tbl-blue">{{ convertItem.nd_clcompany_cd }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">需要家名</th>
            <td>{{ convertItem.clcompany_na }}</td>
            <td class="bg-tbl-blue">{{ convertItem.nd_clcompany_na }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">需要家カナ</th>
            <td>{{ convertItem.dlcompanyka_na }}</td>
            <td class="bg-tbl-blue">{{ convertItem.nd_dlcompanyka_na }}</td>
          </tr>
        </tbody>
      </table>

      <!-- 編集モード-->
      <table
        class="table table-bordered bg-white tbl_master02"
        v-if="!isReferMode"
      >
        <thead>
          <tr class="bg-tbl-head">
            <th style="width: 20%;">項目</th>
            <th style="width: 40%;">お客様データ</th>
            <th style="width: 40%;">日東側データ</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th class="bg-tbl-light">お客様変換CD</th>
            <td>
              <input
                type="tel"
                class="form-control ml-0"
                :class="{
                  'is-invalid':
                    input_error.ngfg_clientdelivery_cd ||
                    input_error.ngfg_duplicate
                }"
                v-model="clientdelivery_cd"
                :disabled="!isNewData"
              />
              <div
                class="invalid-feedback"
                v-if="input_error.ngfg_clientdelivery_cd"
              >
                {{ input_error.msg_clientdelivery_cd }}
              </div>
              <div class="invalid-feedback" v-if="input_error.ngfg_duplicate">
                {{ input_error.msg_duplicate }}
              </div>
            </td>
            <td class="bg-tbl-blue">{{ selected_consumer_cd }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">需要家名</th>
            <td>
              <input
                type="text"
                class="form-control"
                :class="{ 'is-invalid': input_error.ngfg_dlcompany_na }"
                v-model="clcompany_na"
              />
              <div
                class="invalid-feedback"
                v-if="input_error.ngfg_dlcompany_na"
              >
                {{ input_error.msg_dlcompany_na }}
              </div>
            </td>
            <td class="bg-tbl-blue">
              <div class="multiselect-small">
                <multiselect
                  id="consumer_cd"
                  label="consumer_na"
                  trackBy="consumer_cd"
                  placeholder=""
                  selectLabel="選択"
                  selectedLabel="選択中"
                  deselectLabel="選択解除"
                  name="selectedConsumer"
                  v-model="selectedConsumer"
                  :options="consumerList"
                  :class="{ 'is-invalid': input_error.ngfg_consumer_cd }"
                >
                  <span slot="noResult">
                    需要家が見つかりませんでした
                  </span>
                  <span slot="noOptions">
                    需要家が見つかりませんでした
                  </span>
                </multiselect>
              </div>
              <div class="invalid-feedback" v-if="input_error.ngfg_consumer_cd">
                {{ input_error.msg_consumer_cd }}
              </div>
            </td>
          </tr>
          <tr>
            <th class="bg-tbl-light">需要家カナ</th>
            <td>
              <input
                type="text"
                class="form-control"
                :class="{ 'is-invalid': input_error.ngfg_dlcompanyka_na }"
                v-model="dlcompanyka_na"
              />
              <div
                class="invalid-feedback"
                v-if="input_error.ngfg_dlcompanyka_na"
              >
                {{ input_error.msg_dlcompanyka_na }}
              </div>
            </td>
            <td class="bg-tbl-blue">{{ selected_consumerka_na }}</td>
          </tr>
        </tbody>
      </table>
      <div class="btn-center" v-if="!isReferMode">
        <button
          class="btn btn-primary"
          @click="updateConvertConsumerInfoHandler"
        >
          保存
        </button>
      </div>
    </template>
  </section>
</template>

<script>
import {
  // store as loginUser,
  mutations as loginUserMutations
} from "../../../../store/LoginUser";

export default {
  data() {
    return {
      // Search Field
      searchClientdelivery_cd: "",
      searchClcompany_na: "",
      searchDlcompanyka_na: "",

      // Result
      isSearchResult: false,
      searchErrorResponse: {},
      convertJYKList: [],

      page: 1,
      per_page: 10,

      isDetailResult: false,
      detailErrorResponse: {},
      convertItem: null,

      // input Field
      consumer_refer_fg: "",
      consumerList: [],
      process_di: "",
      clientdelivery_cd: "",
      clcompany_na: "",
      dlcompanyka_na: "",
      selectedConsumer: {},
      input_error: {}
    };
  },
  computed: {
    isReferMode() {
      if (this.consumer_refer_fg == "1") {
        return true;
      } else {
        return false;
      }
    },
    searchResultLength() {
      return this.convertJYKList.length;
    },
    filteredsearchResults() {
      const from = (this.page - 1) * this.per_page;
      const to = from + this.per_page;
      return this.convertJYKList.slice(from, to);
    },
    isNewData() {
      if (this.process_di == "0") {
        return true;
      } else {
        return false;
      }
    },
    selected_consumer_cd() {
      if (this.selectedConsumer) {
        return this.selectedConsumer.consumer_cd;
      } else {
        return "";
      }
    },
    selected_consumerka_na() {
      if (this.selectedConsumer) {
        return this.selectedConsumer.consumerka_na;
      } else {
        return "";
      }
    }
  },
  async beforeMount() {
    const response = await this.getInitDataHandler();
    if (response.responseData.return != "0") {
      this.redirectToLogin();
      return;
    }

    // Set Login User Info
    loginUserMutations.setUserInfo(
      this.getAsteriaFirst(response.responseData, "loginUserInfoData")
    );

    // Set input initial data
    this.consumer_refer_fg = response.responseData.consumer_refer_fg;
    this.consumerList = this.getAsteriaArray(
      response.responseData,
      "consumerList"
    );
  },
  methods: {
    /**
     * Get initial data from ASTERIA
     */
    async getInitDataHandler() {
      const response = await this.postAsteria("FileOrder", "getInitData");

      return response;
    },

    /**
     * Search
     */
    async searchConvertConsumerHandler() {
      this.page = 1;
      this.isSearchResult = false;
      this.isDetailResult = false;
      this.searchErrorResponse = {};

      const response = await this.postAsteria(
        "FileOrder",
        "searchConvertConsumer",
        {
          searchClientdelivery_cd: this.searchClientdelivery_cd,
          searchClcompany_na: this.searchClcompany_na,
          searchDlcompanyka_na: this.searchDlcompanyka_na
        }
      );

      if (response.responseData.return != 0) {
        this.searchErrorResponse = response.responseData;
        // window.alert("出荷先変換マスタの検索に失敗しました");
        return;
      }

      this.isSearchResult = true;
      this.convertJYKList = this.getAsteriaArray(
        response.responseData,
        "convertJYKList"
      );
      return response;
    },

    /**
     * Display registration screen
     */
    async registConvertConsumerInfo() {
      this.input_error = {};
      this.selectedConsumer = {};
      this.clientdelivery_cd = "";
      this.clcompany_na = "";
      this.dlcompanyka_na = "";

      this.isDetailResult = true;
      this.process_di = "0";
      this.$nextTick(() => {
        const target = document.querySelector("#detail");
        this.$perfectScrollbar.scrollTo(target);
      });
    },

    /**
     * Get detail data from ASTERIA
     */
    async getConvertConsumerInfoHandler(JYK) {
      this.input_error = {};
      this.selectedConsumer = {};
      this.clientdelivery_cd = "";
      this.clcompany_na = "";
      this.dlcompanyka_na = "";
      this.isDetailResult = false;
      this.detailErrorResponse = {};

      const response = await this.postAsteria(
        "FileOrder",
        "getConvertConsumerInfo",
        {
          searchDelivery_cd: JYK.delivery_cd || "",
          searchClientdelivery_cd: JYK.clientdelivery_cd || "",
          searchCompanyka_na: JYK.dlcompanyka_na || "",
          searchCompany_na: JYK.dlcompany_na || "",
          searchSubfactory_na: JYK.dlsubfactory_na || ""
        }
      );

      if (response.responseData.return != 0) {
        window.alert(response.responseData.message);
        // window.alert("変換マスタ詳細の取得に失敗しました");
        return;
      }

      this.isDetailResult = true;
      this.process_di = "1";
      this.convertItem = this.getAsteriaFirst(
        response.responseData,
        "convertJYK"
      );

      this.clientdelivery_cd = this.convertItem.clientdelivery_cd;
      this.clcompany_na = this.convertItem.clcompany_na;
      this.dlcompanyka_na = this.convertItem.dlcompanyka_na;

      // Set selected consumer
      this.consumerList.forEach(item => {
        if (item.consumer_cd == this.convertItem.nd_clcompany_cd) {
          this.selectedConsumer = {
            row_no: item.row_no,
            consumer_cd: item.consumer_cd,
            consumer_na: item.consumer_na,
            consumerka_na: item.consumerka_na
          };
        }
      });

      this.$nextTick(() => {
        const target = document.querySelector("#detail");

        // target.scrollIntoView({
        //   behavior: "smooth",
        //   block: "center"
        // });
        this.$perfectScrollbar.scrollTo(target);
      });
    },

    /**
     * Update convert consumer info
     */
    async updateConvertConsumerInfoHandler() {
      this.input_error = {};

      if (!window.confirm("保存してもよろしいですか？")) {
        return;
      }

      let consumer_cd = "";
      let consumer_na = "";
      let consumerka_na = "";
      if (this.selectedConsumer) {
        consumer_cd = this.selectedConsumer.consumer_cd;
        consumer_na = this.selectedConsumer.consumer_na;
        consumerka_na = this.selectedConsumer.consumerka_na;
      }

      const response = await this.postAsteria(
        "FileOrder",
        "updateConvertConsumer",
        {
          process_di: this.process_di,
          clientdelivery_cd: this.clientdelivery_cd,
          dlcompany_na: this.clcompany_na,
          dlcompanyka_na: this.dlcompanyka_na,
          consumer_cd: consumer_cd,
          consumer_na: consumer_na,
          consumerka_na: consumerka_na
        }
      );

      if (response.responseData.return != 0) {
        this.input_error = response.responseData;
        return;
      }

      // Clear detail area
      this.isDetailResult = false;
      this.convertItem = null;
      this.process_di = "";
      this.clientdelivery_cd = "";
      this.clcompany_na = "";
      this.dlcompanyka_na = "";
      this.selectedConsumer = {};

      window.alert("需要家変換マスタの登録が完了しました");
      await this.searchConvertConsumerHandler();
    }
  }
};
</script>
